const defaults = () => ({
  itemCreationPrompt: '',
});

export default {
  namespaced: true,
  persist: ['itemCreationPrompt'],
  state: defaults,
  mutations: {
    HYDRATE(state, payload) {
      Object.assign(state, payload);
    },
    SET_ITEM_CREATION_PROMPT(state, value) {
      state.itemCreationPrompt = value;
    },
    RESET(state) {
      Object.assign(state, defaults());
    },
  },
};
